module.exports = __webpack_public_path__ + "static/media/angle-left-solid.6e589c88.svg";